import { createQuery } from "react-query-kit";
import type { AxiosResponse } from "axios";

import type {
  IGuestJoinVideoVisitParams,
  IJoinVideoVisit,
} from "@api/videoVisit/types";
import type { IApiResponse, IAxiosFn } from "@/api";
import { axiosClient, AxiosError } from "@/api";

const key = "guest-join-video-visit";

type IResponse = AxiosResponse<IApiResponse<IJoinVideoVisit>>;
type IVariables = IGuestJoinVideoVisitParams;

export const guestJoinVideoVisit: IAxiosFn<IVariables, IResponse> = async (
  params,
  signal,
) => {
  return axiosClient.get("/guest/join-video-visit", {
    params,
    signal,
  });
};

export const useGuestJoinVideoVisit = createQuery<
  IResponse,
  IVariables,
  AxiosError
>({
  primaryKey: key,
  queryFn: ({ queryKey: [_primaryKey, variables], signal }) =>
    guestJoinVideoVisit(variables, signal),
  retry(_failureCount, error) {
    return error.code !== AxiosError.ERR_BAD_REQUEST;
  },
});
